<template>
  <div class="create-change-order">
    <ProjectHeader :project="project" />
    <ProjectSubNavigation :project="project" />

    <b-card>
      <h3>Change Order</h3>
      <div
        v-for="item in proposal.lineItems"
        :key="item.id"
      >
        <ChangeOrderForm
          :budget-item="item"
          @submitted="saveProposal"
        />
      </div>
      <b-row>
        <b-col>
          <b-button
            variant="none"
            type="button"
            class="btn-lg btn-block mb-2"
            @click.prevent="addBudgetItem()"
          >
            <span class="i-heroicons-plus-circle" /> Add line item
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-b-modal.budgetTemplateModal
            variant="none"
            type="button"
            class="btn-lg btn-block mb-2"
            @click.prevent="budgetTemplateCategoryIndex = categoryIndex"
          >
            <!-- @click.prevent="addBudgetItemTemplate(categoryIndex)" -->
            <span class="i-heroicons-plus-circle" /> Add from template
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Budget, BudgetItem } from '@/models/budget'
import { Customer } from '@/models/customer'
import { Project } from '@/models/project'
import { Proposal } from '@/models/proposal'
import { has, groupBy } from 'underscore'
import ChangeOrderForm from '../components/ChangeOrderForm.vue'
import ProjectSubNavigation from '@/components/project/ProjectSubNavigation.vue'
import ProjectHeader from '@/components/project/ProjectHeader.vue'

export default {
  metaInfo: {
    title: 'Create new change order'
  },

  components: {
    ChangeOrderForm,
    ProjectSubNavigation,
    ProjectHeader
  },

  props: {
    project: { type: Project, required: true},
    budget: { type: Budget, required: true},
    customer: { type: Customer, required: true}
  },

  data: function () {
    return {
      proposal: new Proposal()
    }
  },

  computed: {
    // ...mapGetters('user', ['currentUser']),
    // ...mapGetters('settings', ['getGeneralSettings']),

    lineItemCategories () {
      return groupBy(this.budget.lineItems, (item) => {
        return item.category.name
      })
    },

    getTotalPrice () {
      let totalPrice = 0
      this.budget.lineItems.map((item) => {
        const price =
          typeof item.totalPrice === 'string'
            ? parseFloat(item.totalPrice)
            : item.totalPrice
        totalPrice += price
      })
      return totalPrice
    }
  },

  async created () {
    const validDate = this.proposal.contractDate.getMonth() + 1
    this.proposal.contractValidDate.setMonth(validDate)

    const generalSettings = await this.fetchGeneralSettings()
    this.proposal.termsConditions = has(
      generalSettings,
      'contractTerms'
    )
      ? generalSettings.contractTerms
      : ''

    this.$nextTick(() => {
      this.proposal.projectId = this.project.id
      this.proposal.budgetId = this.budget.id
      this.proposal.preparerId = this.currentUser.id
      this.proposal.customerId = this.project.customerId
    })
  },

  methods: {
    // ...mapActions({
    //   createChangeOrder: 'proposal/createChangeOrder',
    //   fetchGeneralSettings: 'settings/getGeneralSettings'
    // }),

    addBudgetItem () {
      this.proposal.lineItems.push(new BudgetItem())
    },

    async saveProposal (changeOrder) {
      try {
        this.proposal.lineItems.push(changeOrder)

        console.log(this.proposal)

        await this.createChangeOrder(this.proposal)

        this.flash('Change order saved successfully!', 'success')

        this.$router.push({
          name: 'ShowBudget',
          params: { id: this.project.id }
        })
      } catch (err) {
        this.flash(`Error saving change order: ${err}`, 'error')
        console.log('Error: ', err)
      }
    }
  }
}
</script>
